import React from 'react';
import Store from '../../store/Store';

interface WelcomeActionsProps {
    firstName: string;
    lastName: string;
    dashboard: boolean;
    top: boolean;
}

const WelcomeActions: React.FC<WelcomeActionsProps> = ({ firstName, lastName, dashboard, top }) => {
    return (
        <>
            {top && (
                <div>
                    <h1 className="text-3xl font-bold">
                        Willkommen {firstName} {lastName}!
                    </h1>
                    <p className="mb-8 text-2xl">
                        Was möchten Sie heute machen?
                    </p>
                </div>
            )}
            <div className={`bg-white rounded-full flex items-center px-4 font-semibold${!top ? ' py-2' : ' py-3 mb-4'}`}
                style={{ boxShadow: '0 6px 20px -4px rgba(0,0,0,0.12)' }}>

                <div className="flex items-center overflow-hidden rounded-full w-full">
                    <button
                        className="px-6 hover:text-red-500 transition-colors"
                        onClick={() => {
                            Store.navigate('orders');
                            Store.loadOrders();
                        }}
                        data-pw="button-consumer-dashboard-orders"
                        aria-label="Meine Aufträge"
                    >
                        {!top ? 'Meine Aufträge' : 'Meine Aufträge verwalten'}
                    </button>
                    <div className={`w-px ${top ? 'h-[2px]' : 'h-6'} bg-gray-200 menu-line`} />
                    <button
                        data-pw="button-consumer-dashboard-search"
                        onClick={() => Store.navigate('search')}
                        className="px-6 hover:text-red-500 transition-colors"
                        aria-label="Öffentliche Drohnendaten suchen"
                    >
                        {top ? 'Öffentliche Drohnendaten suchen' : 'Öffentliche Drohnendaten'}
                    </button>
                    <div className={`w-px ${top ? 'h-[1rem]' : 'h-6'} bg-gray-200 menu-line`} />
                    <button
                        data-pw="button-consumer-dashboard-book"
                        onClick={() => Store.startBooking()}
                        className="px-6 text-red-500 hover:text-[#CB2D0E] transition-opacity"
                        aria-label="Drohnenflug buchen"
                    >
                        {top ? 'Einen Drohnenflug buchen' : 'Drohnenflug buchen'}
                    </button>
                    <button
                        onClick={() => Store.startBooking()}
                        className={`bg-[#E1320F] text-white ${!top ? 'w-10 h-10' : 'w-14 h-14'} flex items-center justify-center rounded-full text-base ml-2 mr-2 hover:bg-red-600 transition-colors`}
                        data-pw="button-consumer-dashboard-book-round"
                        aria-label="Drohnenflug buchen rund"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M5 12H19M19 12L13 6M19 12L13 18" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </button>
                </div>
            </div>
        </>
    );
};

export default WelcomeActions;